<template>
  <ParentPortal :tabs="sidePanelComponents">
    <router-view v-if="report" :report="report" class="main-content"/>
  </ParentPortal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { IfacAwardDetails, IfacNominationReferences } from '@ifac/ui';
import nominationsMixin from '@/mixins/awards/nominations.mixin';
import ParentPortal from '@/views/components/portals/ParentPortal.vue';
import { mapGetters } from 'vuex';
import Reports from '@/services/Api/Awards/Reports';

export default {
  mixins: [nominationsMixin],
  name: 'NominationsEditPortal',
  components: {
    ParentPortal,
    IfacAwardDetails,
    IfacNominationReferences,
  },
  created() {
    this.fetchAwardReport();
  },
  methods: {
    fetchAwardReport() {
      Reports.get(this.reportId).then((response) => {
        this.report = response.data.data;
      });
    },
  },
  data() {
    return {
      report: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    sidePanelComponents() {
      return [
        {
          icon: ['far', 'award'],
          headerText: 'Award',
          component: IfacAwardDetails,
          options: {
            award: this.report?.reportable,
            isLoading: false,
          },
        },
      ];
    },
    reportId() {
      return this.$route.params.report;
    },
  },
};
</script>
